import { Center, Image, Stack, Title } from '@mantine/core'
import Gem from '../assets/GemIcon.png'

function PaymentSuccessPage() {
  return (
    <Center>
      <Stack align="center">
        <Image src={Gem} w={100} pb={75} />
        <Title size="h1">Thanks for advertising with us!</Title>
        <Title size="h3">Your ad will start running soon</Title>
      </Stack>
    </Center>
  )
}

export default PaymentSuccessPage
